import { EXTENSIONS } from 'probonio-shared-ui/registry';
import { ExtensionBuilder } from 'probonio-shared-ui/registry/extension-definition';
import { BenefitListItemExtensionInterface } from '../../../extension/interface/benefit-list-item.extension.interface';
import { BenefitMetadataExtensionInterface } from '../../../extension/interface/benefit-metadata.extension.interface';
import { NewsBenefitListItemExtension } from './news-benefit-list-item.extension';
import { NewsBenefitMetadataExtension } from './news-benefit-metadata.extension';

EXTENSIONS.registerExtension(
  new ExtensionBuilder('news')
    .add(BenefitMetadataExtensionInterface, new NewsBenefitMetadataExtension())
    .add(BenefitListItemExtensionInterface, new NewsBenefitListItemExtension())
    .build(),
);
